var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"variant":"gradient-info"},on:{"click":_vm.sendFile}},[_vm._v(" Eviar ")]),_c('b-form-file',{ref:"files",attrs:{"id":"files","accept":"image/*","name":"Arquivo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }